import React from 'react'

import SignalRHub from './Hub'

export class WebSocketData {
  hub?: SignalRHub

  constructor(hub?: SignalRHub) {
    this.hub = hub
  }
}

export const WebSocketContext = React.createContext<WebSocketData>(new WebSocketData())
